/**
 * Feature flags for controlling UI visibility
 * Toggle these to switch between waitlist and regular signup flows
 */
export const FEATURES = {
  /** Show "Join Waitlist" button - for waitlist mode */
  SHOW_WAITLIST: true,

  /** Show "Sign Up" button - for regular registration mode */
  SHOW_SIGNUP: false,
} as const;

/** User type options for waitlist registration */
export const USER_TYPES = [
  { value: 'business_owner', label: 'Business Owner' },
  { value: 'ca_accounting_firm', label: 'CA / Accounting Firm' },
  { value: 'cfo_finance_head', label: 'CFO / Finance Head' },
] as const;

export type UserType = typeof USER_TYPES[number]['value'];
